import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../service/requestHandler";

export const budgetedVsActualCostTrend = createDynamicThunk(
  "budgetedVsActualCostTrend",
  "/report/api/v1/cloudCostInsightsController/getBudgetVsActualCost"
);

export const costTrendApplication = createDynamicThunk(
  "costTrendApplication",
  "/report/api/v1/cloudCostInsightsController/getCostTrendByApplication"
);

export const costTrendAccountId = createDynamicThunk(
  "costTrendAccountId",
  "/report/api/v1/cloudCostInsightsController/getCostTrendByAccountName"
);

export const costTrendResources = createDynamicThunk(
  "costTrendResources",
  "/report/api/v1/cloudCostInsightsController/getCostTrendByResource"
);

export const costTrendRegion = createDynamicThunk(
  "costTrendRegion",
  "/report/api/v1/cloudCostInsightsController/getCostTrendByRegion"
);

export const cloudCost = createDynamicThunk(
  "cloudCost",
  "/report/api/v1/cloudCostInsightsController/getCloudCostDetailsList",
  ["pageNumber", "itemsPerPage"]
);

export const cloudCostDrill = createDynamicThunk(
  "cloudCostDrill",
  "/report/api/v1/cloudCostInsightsController/getCloudCostDetailsListDrillDownOne",
  ["pageNumber", "itemsPerPage"]
);

export const cloudCostDrillDown = createDynamicThunk(
  "cloudCostDrillDown",
  "/report/api/v1/cloudCostInsightsController/getCloudCostDetailsListDrillDownTwo",
  ["appCodes", "accountId", "pageNumber", "itemsPerPage"]
);

export const cloudCostPagenation = createDynamicThunk(
  "cloudCostPagenation",
  "/api/v1/cloudCostInsightsController/getCloudCostDetailsListCount"
);

export const cloudCostDrillPagenation = createDynamicThunk(
  "cloudCostDrillPagenation",
  "/api/v1/cloudCostInsightsController/getCloudCostDetailsListDrillDownOneCount"
);

export const cloudCostRegionCount = createDynamicThunk(
  "cloudCostRegionCount",
  "/api/v1/cloudCostInsightsController/getCloudCostDetailsListDrillDownTwoCount",
  ["accountId"]
);

export const getFilteredCSP = createDynamicThunk(
  "getFilteredCSP",
  "/api/v1/CSPForAws/appCodes"
);

export const initialState = {
  budgetedVsActualCostTrendData: [],
  budgetedVsActualCostTrendDataLoading: false,
  costTrendApplicationData: [],
  costTrendApplicationDataLoading: false,
  costTrendAccountIdData: [],
  costTrendAccountIdDataLoading: false,
  costTrendResourcesData: [],
  costTrendResourcesDataLoading: false,
  costTrendRegionData: [],
  costTrendRegionDataLoading: false,
  cloudCostData: [],
  cloudCostDataLoading: false,
  cloudCostDrillData: [],
  cloudCostDrillDataLoading: false,
  cloudCostDrillDownData: [],
  cloudCostDrillDownDataLoading: false,
  cloudCostPagenationData: [],
  cloudCostPagenationLoading: false,
  cloudCostDrillPagenationData: [],
  cloudCostDrillPagenationLoading: false,
  cloudCostRegionCountData: [],
  cloudCostRegionCountLoading: false,
  getFilteredCSPData: [],
  getFilteredCSPLoading: false,
};

export const CostSlice = createSlice({
  name: "CostSlice",
  initialState,
  reducers: {
    resetCostSlice: () => initialState,
    resetCostData: (state, action) => {
      state.budgetedVsActualCostTrendData = action.payload;
      state.budgetedVsActualCostTrendDataLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    addApiCases(
      builder,
      budgetedVsActualCostTrend,
      "budgetedVsActualCostTrendData"
    );
    addApiCases(builder, costTrendApplication, "costTrendApplicationData");
    addApiCases(builder, costTrendAccountId, "costTrendAccountIdData");
    addApiCases(builder, costTrendResources, "costTrendResourcesData");
    addApiCases(builder, costTrendRegion, "costTrendRegionData");
    addApiCases(builder, cloudCost, "cloudCostData");
    addApiCases(builder, cloudCostDrill, "cloudCostDrillData");
    addApiCases(builder, cloudCostDrillDown, "cloudCostDrillDownData");
    addApiCases(builder, cloudCostPagenation, "cloudCostPagenationData");
    addApiCases(
      builder,
      cloudCostDrillPagenation,
      "cloudCostDrillPagenationData"
    );
    addApiCases(builder, cloudCostRegionCount, "cloudCostRegionCountData");
    addApiCases(builder, getFilteredCSP, "getFilteredCSPData");
  },
});

export const { resetCostSlice, resetCostData } = CostSlice.actions;
export default CostSlice.reducer;
